import { stardust } from '@eidellev/adonis-stardust/client';
import Pristine from './pristine';
import { displayGenericError } from './form-errors';
import { getPageLang, wait } from './utils';
import Choices from 'choices.js';

/*
 * Add the class 'js-form' to the form to get it to submit and be validated using Pristine
 * Add a 'data-route' attribute to the form to specify where it will submit to (it gets added to '/form/')
 *	TODO: that route can be changed to whatever it needs to be and then just needs to be updated on line #72
 * Add a div.success-wrapper within the form for the success message
 * To specify the success message add the 'data-msg' attribute to the div.success-wrapper
 * (otherwise the message will default to ' Success!')
 * Add a div.error-wrapper within the form for any error messages
 */

/** Enable or disable a form's inputs */
function updateInputs(form: HTMLFormElement, disable: boolean) {
  const inputs = form.querySelectorAll('input, textarea, button');
  inputs.forEach(function(input) {
    if (disable) {
      input.setAttribute('disabled', 'true');
    } else {
      input.removeAttribute('disabled');
    }
  });
}

function showSuccess(form: HTMLFormElement) {
  const successWrapper = form.querySelector<HTMLElement>('.success-wrapper');
  if (!successWrapper) {
    return;
  }

  // TODO: Use i18n for default success (and fail) messages?
  // Looks like all our forms using this have their own messages specified
  const successMsg = successWrapper.getAttribute('data-msg')
    ? successWrapper.getAttribute('data-msg')
    : 'Success!';

  const msgWrapper = document.createElement('span');
  msgWrapper.textContent = successMsg;
  successWrapper.appendChild(msgWrapper);

  successWrapper.focus();
}

function hideAllMsgs(form: HTMLFormElement) {
  const successWrapper = form.querySelector<HTMLElement>('.success-wrapper');
  const errorsWrapper = form.querySelector<HTMLElement>('.errors-wrapper');

  if (successWrapper) {
    successWrapper.innerHTML = '';
  }

  if (errorsWrapper) {
    errorsWrapper.innerHTML = '';
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  const selects = document.querySelectorAll<HTMLSelectElement>('.input__select');

  selects.forEach((select) => {
    new Choices(select, {
      searchEnabled: false,
      itemSelectText: '', // removes the "Press to select" text
      shouldSort: false, // keep original order
    });

    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (!form) {
        return;
      }

      // Find the pristine instance for this form
      const pristine = (form as any)._pristine as Pristine | undefined;
      // console.debug(pristine);
      if (pristine) {
        pristine.validate(select); // revalidate just this field
      }
    });
  });

  const forms = [].slice.call(document.querySelectorAll('.js-form'));
  forms.forEach(function(form: HTMLFormElement) {
    const pristine = new Pristine(form, {
      classTo: 'form__input',
      errorTextParent: 'form__input',
    });

    (form as any)._pristine = pristine;

    // Optional delayed auto-close closest modal on success
    const autoCloseDelayAttr = form.getAttribute('data-auto-close-delay');
    const autoCloseDelay = autoCloseDelayAttr ? parseInt(autoCloseDelayAttr) : null;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      hideAllMsgs(form);

      const valid = pristine.validate();

      // console.log(`valid: ${valid}`);

      if (valid) {
        const route = form.getAttribute('data-route') as string;
        const formData = new FormData(form);

        // Add language to form submission
        const lang = getPageLang();
        formData.append('lang', lang);

        // Disable inputs while submitting
        updateInputs(form, true);

        // console.log(formData);

        try {
          const fetchUrl = stardust.route(route);
          const response = await fetch(fetchUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
          });

          const json = await response.json();
          console.debug({ response: json });

          // Display any errors returned from the backend
          if (!response.ok) {
            displayGenericError(form);
            return;
          }

          showSuccess(form);

          if (autoCloseDelay) {
            const modalName = form.closest('.modal')?.getAttribute('data-modal');
            if (!modalName) {
              console.error('No modal found to close');
              return;
            }
            await wait(autoCloseDelay);
            window.closeModal(modalName);
          }

          // ??? Leave fields disabled so the user doesn't submit the form twice?
          // updateInputs(form, false); // enable inputs
        } catch (error) {
          console.error(error);
          displayGenericError(form);
          updateInputs(form, false); // enable inputs
        }
      }
    });
  });
});
